import {LOCALE_ID, NgModule} from '@angular/core';
import {IonicApp, IonicModule} from 'ionic-angular';
import {MyApp} from './app.component';
import { BrowserModule } from '@angular/platform-browser'
import {CartPage} from '../pages/cart/cart';
import {CouponsPage} from '../pages/coupons/coupons';
import {MenuPage} from '../pages/menu/menu';
import {SettingsPage} from '../pages/settings/settings';
import {ProfilePage} from '../pages/profile/profile';
import {TabsPage} from '../pages/tabs/tabs';
import {EmptyStateDirective} from "../components/empty-state/empty-state";
import {API} from "./services/api.service";
import {MenuViewPage} from "../pages/menuview/menuview";
import {MinimumOrderValuePage} from "../pages/minimum-order-value/minimum-order-value";
import {OpeningTimesPage} from "../pages/opening-times/opening-times";
import {AddressPage} from "../pages/address/address";
import {AddAddressPage} from "../pages/address/add_address";
import {RegisterPage} from "../pages/register/register";
import {ProductOptionPage} from "../pages/product-option/product-option";
import {PhonenumberPage} from "../pages/phonenumber/phonenumber";
import {FavoritePage} from "../pages/favorite/favorite";
import {CheckoutPage} from "../pages/checkout/checkout";
import {OrderSubmitPage} from "../pages/order-submit/order-submit";
import {StaticPage} from "../pages/static/static";
import {SafeHtml} from "./pipes/trust";
import {FilterPipe} from "./pipes/filter";
import {ProductSizePage} from "../pages/product-size/product-size";
import {AuthorizedHttpClient} from "./classes/authorized_http_client";
import {AnalyticsService} from "./services/analytics.service";
import {ProductVariationModule} from "../pages/product-variation/product-variation.module";
import {UserOrdersModule} from "../pages/user-orders/user-orders.module"
import {SystemMessages} from "../components/system-messages/system-messages";
import {ReportErrorPage} from "../pages/report-error/report-error";
import {HttpModule} from "@angular/http";
import { registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de';
import {HTTP} from "@ionic-native/http";
import { PricePipe } from './pipes/getPrice';
import {StorageService} from "./services/storage.service";
import {ProductSpecialPage} from "../pages/product-special/product-special";
import {OrderSummaryPage} from "../pages/order-summary/order-summary";

registerLocaleData(localeDe);

@NgModule({
  declarations: [
    MyApp,
    CartPage,
    MenuPage,
    CouponsPage,
    SettingsPage,
    ProfilePage,
    TabsPage,
    MenuViewPage,
    EmptyStateDirective,
    MinimumOrderValuePage,
    OpeningTimesPage,
    AddressPage,
    AddAddressPage,
    RegisterPage,
    ProductOptionPage,
    PhonenumberPage,
    FavoritePage,
    CheckoutPage,
    OrderSubmitPage,
    StaticPage,
    SafeHtml,
    FilterPipe,
    PricePipe,
    ProductSizePage,
    SystemMessages,
    ReportErrorPage,
    ProductSpecialPage,
    OrderSummaryPage
  ],
  imports: [
    IonicModule.forRoot(MyApp),
    BrowserModule,
    HttpModule,
    ProductVariationModule,
    UserOrdersModule,
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    CartPage,
    MenuPage,
    CouponsPage,
    SettingsPage,
    ProfilePage,
    TabsPage,
    MenuViewPage,
    MinimumOrderValuePage,
    OpeningTimesPage,
    AddressPage,
    AddAddressPage,
    RegisterPage,
    ProductOptionPage,
    StaticPage,
    PhonenumberPage,
    ProductSpecialPage,
    FavoritePage,
    CheckoutPage,
    OrderSubmitPage,
    ProductSizePage,
    ReportErrorPage,
    OrderSummaryPage

  ],
  exports: [
    PricePipe,
  ],
  providers: [
    {provide: API, useClass: API},
    {provide: AnalyticsService, useClass: AnalyticsService},
    {provide: StorageService, useClass: StorageService},
    {provide: LOCALE_ID, useValue: 'de-AT'},
    AuthorizedHttpClient,
    HTTP,
  ]
})
export class AppModule {
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts